// Logging Interfaces
export interface ICustomLogData {
	[key: string]: string | number | boolean | undefined;
}

export interface IPersonalizationLogger {
	error(message: string, ...data: unknown[]): void;
	info(message: string, ...data: unknown[]): void;
	warn(message: string, ...data: unknown[]): void;
	trace(message: string, ...data: unknown[]): void;
	event(eventName: string, customLogData?: ICustomLogData, samplingRatio?: number): void;
	userFactEvent?(userFact: string, userFactValue: string): void;
}

let globalLogger: IPersonalizationLogger = {
	error(message: string, ...data: unknown[]): void {},
	info(message: string, ...data: unknown[]): void {},
	warn(message: string, ...data: unknown[]): void {},
	trace(message: string, ...data: unknown[]): void {},
	event(eventName: string, customLogData?: ICustomLogData, samplingRatio = 1): void {},
	userFactEvent(eventName: string, userFactValue: string): void {},
};

export function getLogger(): IPersonalizationLogger {
	return globalLogger;
}

export function setLogger(logger: IPersonalizationLogger): void {
	if (logger) {
		globalLogger = logger;
	}
}
